import { render, staticRenderFns } from "./AccountUser.vue?vue&type=template&id=58df0bf4&scoped=true"
import script from "./AccountUser.vue?vue&type=script&lang=js"
export * from "./AccountUser.vue?vue&type=script&lang=js"
import style0 from "./AccountUser.vue?vue&type=style&index=0&id=58df0bf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58df0bf4",
  null
  
)

export default component.exports